import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { QRCodeModule } from 'angularx-qrcode';
import { AssessmentModule } from '../assessment/assessment.module';
import { ContactCrComponent } from '../mdm/contact/change-requests/contact-cr';
import { PhoneCallDetailsComponent } from '../phonecall/phone-call-details/phone-call-details';

import { ContactPageComponent } from './contact-page/contact-page';
import { ContactCallPlanComponent } from './contact-call-plan/contact-call-plan';
import { CallPlanProgressBar } from '../call-plans/call-plan-progress/call-plan-progress';
import { ContactListComponent } from './contact-list/contact-list';
import { ContactDetailsComponent } from './contact-details/contact-details';
import { ContactInfoComponent } from './contact-info/contact-info';
import { ContactNewAddressComponent } from './contact-change/contact-address/contact-address-add';
import { ContactTimelineComponent } from './contact-timeline/contact-timeline';
import { ContactConsentComponent } from './contact-consent/contact-consent';
import { ContactConsentCaptureComponent } from './contact-consent-capture/contact-consent-capture';
import { ConsentDetailsComponent } from './consent-details/consent-details';
import { ConsentTermDetailsComponent } from './consent-term-details/consent-term-details';
import { ContactProfileComponent } from './contact-profile/contact-profile';
import { ScientificInfoDetailsComponent } from './scientific-info-details/scientific-info-details';
import { PublicationPreviewComponent } from './publication-preview/publication-preview';
import { ContactListROComponent } from './contact-list-ro/contact-list-ro';
import { ContactAcountAffiliationComponent } from './contact-change/contact-account/contact-acount-affiliation';
import { MeetingAttendiesListComponent } from './meeting-attendies-list/meeting-attendies-list';
import { ChannelDetailCardComponent } from './channel-detail-card/channel-detail-card';
import { CustomerInsightComponent } from './customer-insight/customer-insight';
import { CustomerJourneyComponent } from './customer-insight/customer-journey/customer-journey';
import { CustomerRelationshipComponent } from './customer-insight/customer-relationship/customer-relationship';
import { CustomerInterestComponent } from './customer-insight/customer-interest/customer-interest';
import { XperiencePlanInsightComponent } from './xperience-plan-insight/xperience-plan-insight';
import { ConsentSignatureModalComponent } from './consent-signature-modal/consent-signature-modal';
import { CustomerAvailabilityComponent } from './customer-availability/customer-availability.component';
import { AddCustomerAvailabilityComponent } from './add-customer-availability/add-customer-availability.component';
import { KOLStatusPageComponent } from './kol-status-page/kol-status-page';
import { KOLStatusListComponent } from './kol-status-list/kol-status-list';
import { KOLStatusDetailsComponent } from './kol-status-details/kol-status-details';
import { ContactMedicalInsightComponent } from './contact-medical-insight/contact-medical-insight';
import { HopQRCodeModal } from './hop-qr-code-modal/hop-qr-code-modal';
import { MdmMaterialModal } from './mdm-material/mdm-material-modal';
import { MedicalInsightPageComponent } from './medical-insight-page/medical-insight-page';
import { MedicalInsightListComponent } from './medical-insight-list/medical-insight-list';
import { AllocationEligibilityComponent } from './allocation-eligibility/allocation-eligibility';
import { ContactFeedComponent } from './contact-feed/contact-feed';
import { ContactTimelinePageComponent } from './contact-timeline-page/contact-timeline-page';
import { ContactOmnichannelEventsComponent } from './contact-omnichannel-events/contact-omnichannel-events';
import { ContactSentimentHistoryListComponent } from './contact-sentiment-history-list/contact-sentiment-history-list';
import { ContactOmnichannelOpportunitiesComponent } from './contact-omnichannel-opportunities/contact-omnichannel-opportunities';
import { ContactVeevaWidgetComponent } from './contact-veeva-widget/contact-veeva-widget';
import { ContactNameSequencePipe } from '../../pipes/common-pipes/contact-name-sequence.pipe';
import { LocationComponent } from '../location/location';
import { SpotlightAiSummaryComponent } from './contact-spotlight/spotlight-ai-summary/spotlight-ai-summary.component';
import { NovaRecordContextDirective } from '../nova-voice/nova-record-context.directive';

const CONTACT_DECLARATIONS = [
  ContactPageComponent,
  ContactListComponent,
  ContactDetailsComponent,
  ContactInfoComponent,
  ContactNewAddressComponent,
  ContactTimelineComponent,
  ContactConsentComponent,
  ContactConsentCaptureComponent,
  ConsentDetailsComponent,
  ConsentTermDetailsComponent,
  ContactProfileComponent,
  ScientificInfoDetailsComponent,
  PublicationPreviewComponent,
  ContactListROComponent,
  ContactAcountAffiliationComponent,
  MeetingAttendiesListComponent,
  ChannelDetailCardComponent,
  CustomerInsightComponent,
  CustomerJourneyComponent,
  CustomerRelationshipComponent,
  CustomerInterestComponent,
  XperiencePlanInsightComponent,
  ConsentSignatureModalComponent,
  CustomerAvailabilityComponent,
  AddCustomerAvailabilityComponent,
  KOLStatusPageComponent,
  KOLStatusListComponent,
  KOLStatusDetailsComponent,
  ContactMedicalInsightComponent,
  HopQRCodeModal,
  MdmMaterialModal,
  MedicalInsightPageComponent,
  MedicalInsightListComponent,
  AllocationEligibilityComponent,
  ContactFeedComponent,
  ContactTimelinePageComponent,
  ContactOmnichannelEventsComponent,
  ContactSentimentHistoryListComponent,
  ContactOmnichannelOpportunitiesComponent,
  ContactVeevaWidgetComponent,
  ContactNameSequencePipe,
  LocationComponent,
];

@NgModule({
  imports: [SharedModule, QRCodeModule, AssessmentModule, ContactCrComponent, SpotlightAiSummaryComponent, PhoneCallDetailsComponent, NovaRecordContextDirective, ContactCallPlanComponent, CallPlanProgressBar],
  declarations: CONTACT_DECLARATIONS,
  exports: CONTACT_DECLARATIONS,
  // contact-details.html: <customer-assess>, <customer-assess-teamview> (AssessmentModule),
  //   <adoption-ladder-journey> (SharedModule), <app-spotlight-ai-summary> (standalone)
  // contact-profile.html: <contact-call-plan> (standalone)
  // contact-list.html: <contact-cr> (standalone ContactCrComponent), <call-plan-progress-bar> (standalone)
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ContactModule {}
